import React from 'react';
import { z } from 'zod';

import defineBlock from './helpers/defineBlock';

export const SpacerBlockSchema = defineBlock(
  'Spacer',
  z.object({
    height: z.number().nullish(),
  })
);
export type TSpacerBlock = z.infer<typeof SpacerBlockSchema>;

type SpacerBlockProps = {
  block: TSpacerBlock;
};
export default function SpacerBlock({ block }: SpacerBlockProps) {
  const h = block.props?.height;
  const height = typeof h === 'number' ? h : 16;
  return <div style={{ height: `${height}px` }} />;
}
